// Company data
export const CompanyName = 'Siv Renate';
// export const CompanyPhoneNumber = '123456789';
// export const CompanyWhatsappNumber = '123456789';
export const CompanyEmailAddress = 'sivrsm@gmail.com';
export const DirectorName = 'Siv Renate Skaufel';
export const LocationCity = 'Drammen';
export const LocationCountry = 'Norway';

// Address Constants
export const AddressLine1 = '';
export const AddressLine2 = '';
export const AddressLine3 = '';
export const AddressLine4 = '';
export const PostalCode = '';

export const CompanyTagLine = 'Helping brands grow and people thrive';
export const MainTitle = 'Commercials & Wellness Coaching';
export const SubtitleMain = 'Modern, simple, worldwide services';
export const SubtitleSecondary = `How can ${CompanyName} help you?`;

export const KeywordsPages =
  'Siv Renate, Commercials, UGC Creator, Wellness Coaching, Mental Wellness, Worldwide coaching, Drammen Norway';

// Cookie data
export const NumberOfCookies = 0;
export const COOKIE_TIMER = 10000;
export const CookiePolicyName = 'CookiePolicy';

// Business URL
export const FULL_BUSINESS_URL = 'https://www.srskaufelkreativemedie.com';
export const SHORT_BUSINESS_URL = 'srskaufelkreativemedie.com';
export const DISPLAY_BUSINESS_URL = 'www.srskaufelkreativemedie.com';

// Social Media URLs
export const FACEBOOK_URL = '';
export const INSTAGRAM_URL = 'https://www.instagram.com/grundercoach_sivrenate?igsh=MWtoMmc4c3M3ZXBnZQ%3D%3D&utm_source=qr';
export const GOOGLE_URL = '';
export const GITHUB_URL = '';
export const APPLE_URL = '';
export const LINKEDIN_URL = '';
export const X_URL = '';
export const TWITTER_URL = '';
export const TIKTOK_URL = 'https://www.tiktok.com/@wellnesscoach_sivrenate?_t=ZN-8znwWJ0irOp&_r=1';
export const UPWORK_URL = 'https://www.upwork.com/freelancers/~011030c2006414fb76?companyReference=1816915030632194049&mp_source=share';

// Maps
export const GoogleMapsEmbedUrl = "";

// Bot Data
export const BotName = 'Jerry';

export const UPLOAD_CONCURRENCY = 4;
